import React from 'react';
import PropTypes from 'prop-types';

import Modal from 'react-bootstrap/Modal';

import AddOrganization from '../../components/AddOrganization';

function OrganizationModal(props) {
  const {
    show,
    onHide,
    handleSetOrganization,
    setDefaultOrg,
    openBuildingModal,
    showToast,
    history,
  } = props;

  return (
    <Modal show={show} onHide={onHide}>
      <AddOrganization
        onHide={onHide}
        handleSetOrganization={handleSetOrganization}
        setDefaultOrg={setDefaultOrg}
        openBuildingModal={openBuildingModal}
        showToast={showToast}
        history={history}
      />
    </Modal>
  );
}

OrganizationModal.propTypes = {
  portfolioId: PropTypes.number,
  show: PropTypes.bool.isRequired,
  onHide: PropTypes.func.isRequired,
  handleSetOrganization: PropTypes.func,
  showToast: PropTypes.func,
};

export default OrganizationModal;
